(function() {
    jQuery(document).ready(function () {
        var owlDots = jQuery('.main-slider.owl-theme .owl-dots');
        
        if(owlDots.length == 0)
            return; // when there is no main slider, so don't run this script

        function positionDotsNav() {
            var headline = jQuery('.main-slider .active .slide h2 span.second-word');
            var offset, headlineHeight, dotsHeight;
            offset = parseInt(headline.offset().top);
            headlineHeight = parseInt(headline.height());
            dotsHeight = parseInt(owlDots.height());
            var top = offset + headlineHeight - dotsHeight;

            owlDots.css( "top", top + "px");
        }

        positionDotsNav();

        var doit;
        window.onresize = function() {
            clearTimeout(doit);
            doit = setTimeout(positionDotsNav, 150);
        }
        window.addEventListener('load', function() {
            positionDotsNav();
        })
    });
})()